import React, { useState, useEffect } from 'react';
import { Modal, Offcanvas } from 'react-bootstrap';

const ClientForm = ({
  showModal,
  handleClose,
  clientId,
  clientData,
  addClient,
  editClient,
  clientIdError,
  clients,
  countries, contacts,
  type,
  fetchCountries
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    address: '',
    pay_term: '',
    alternate_contact_no: '',
    country_id: '',
    state: '',
    city: '',
    zip: '',
    business_name: '',
    avatar: '',
    tax_number: '',
    tl_registration: '',
    pay_term_condition: '',
    currency: '',
    tl_registration_date: '',
    tl_registration_doc: '',
    tl_expired_date: '',
    short_code: '',
    rcm_eligible: null,


  });

  const [errors, setErrors] = useState({});


  useEffect(() => {
    if (showModal && countries.length === 0) {
      fetchCountries();
    }
    if (showModal && !clientData) {
      // Reset formData for new client creation
      setFormData({
        name: '',
        email: '',
        mobile: '',
        address: '',
        pay_term: '',
        alternate_contact_no: '',
        country_id: '',
        state: '',
        city: '',
        zip: '',
        business_name: '',
        avatar: '',
        tax_number: '',
        tl_registration: '',
        pay_term_condition: '',
        currency: '',
        tl_registration_date: '',
        tl_registration_doc: '',
        tl_expired_date: '',
        short_code: '',
        rcm_eligible: null,


      });
    } else if (clientData) {
      // Populate formData for editing a client
      setFormData({
        name: clientData.name || '',
        email: clientData.email || '',
        mobile: clientData.mobile || '',
        address: clientData.address || '',
        pay_term: clientData.pay_term || '',
        alternate_contact_no: clientData.alternate_contact_no || '',
        country_id: clientData.country_id || '',
        state: clientData.state || '',
        city: clientData.city || '',
        zip: clientData.zip || '',
        business_name: clientData.business_name || '',
        avatar: clientData.avatar || '',
        tax_number: clientData.tax_number || '',
        tl_registration: clientData.tl_registration || '',
        pay_term_condition: clientData.pay_term_condition || '',
        currency: clientData.currency || '',
        tl_registration_date: clientData.tl_registration_date || '',
        tl_registration_doc: clientData.tl_registration_doc || '',
        tl_expired_date: clientData.tl_expired_date || '',
        short_code: clientData.short_code || '',
        rcm_eligible:
          clientData.rcm_eligible === null || clientData.rcm_eligible === undefined
            ? null
            : (clientData.rcm_eligible === true || clientData.rcm_eligible === 1 || clientData.rcm_eligible === '1' || clientData.rcm_eligible === 'true'),

      });
    }
  }, [clientData, showModal]);

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;
    const nextValue = type === 'checkbox' ? checked : value;
    setFormData({ ...formData, [name]: nextValue });
    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    }
  };


  const handleFileChange = (event) => {
    const { name, files } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0], // Save the first file in the state
    }));
  };

  useEffect(() => {
    if (!showModal) {
      setErrors({});
    }
  }, [showModal]);
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.country_id) newErrors.country_id = 'Please Select';
    const duplicateInstance = contacts.some(
      (contact) => contact.name === formData.name && contact.id !== (clientData?.id || null)
    );
    if (duplicateInstance) {
      newErrors.name = 'name must be unique';
    }


    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return; // Stop here if validation fails
    }
    let apierrors;
    if (clientData) {
      apierrors = await editClient(clientData.id, formData);
    } else {
      apierrors = await addClient(formData);
    }

    if (apierrors && Object.keys(apierrors).length > 0) {
      setErrors(apierrors); // Display validation errors
    } else {
      setErrors({}); // Clear errors on success
      handleClose(); // Close modal on success
    }
  };
  const [currency, setCurrency] = useState('');
  useEffect(() => {
    const selectedCountry = countries.find(
      (country) => String(country.id) === String(formData.country_id)
    );

    if (selectedCountry?.name === 'United Arab Emirates') {
      setCurrency('AED');
      setFormData((prev) => ({
        ...prev,
        currency: 'AED',
      }));
    } else {
      setCurrency('USD');
      setFormData((prev) => ({
        ...prev,
        currency: 'USD',
      }));
    }
  }, [formData.country_id, countries]);


  return (
    <>
      <div>
        {showModal && (
          <div
            className="project-modal-backdrop"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255, 255, 255, 0.2)', // light white transparent
              zIndex: 1048, // ✅ keep it below the modal backdrop (Bootstrap's 1050)
              pointerEvents: 'none', // ✅ prevent blocking modal clicks
              backdropFilter: 'blur(2px)',
              WebkitBackdropFilter: 'blur(2px)',
              transition: 'opacity 0.3s ease',
            }}
          />
        )}
      </div>

      <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ width: '600px' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {clientId
              ? `Edit ${type === 'client' ? 'Client' : type === 'vendor' ? 'Vendor' : type === 'lead' ? 'Project Lead' : 'Project Manager'}`
              : `Add ${type === 'client' ? 'Client' : type === 'vendor' ? 'Vendor' : type === 'lead' ? 'Project Lead' : 'Project Manager'}`}
          </Offcanvas.Title>



        </Offcanvas.Header>
        <hr style={{ margin: 0 }} />

        <Offcanvas.Body>
          <form >
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="name" className="form-label form-font">Name:</label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    className={`form-input form-control ${errors?.name ? 'is-invalid' : ''}`}
                    value={formData.name}
                    onChange={handleChange}

                  />
                  {errors.name && <div className="invalid-feedback font-size-12" >*{errors.name}</div>}

                </div>
              </div>
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="short_code" className="form-label form-font">Short Code:</label>
                  <input
                    type="text"
                    name="short_code"
                    id="short_code"
                    className="form-control form-input"
                    value={formData.short_code}
                    onChange={handleChange}

                  />
                </div>

              </div>
            </div>
            <div className="row">
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="business_name" className="form-label form-font">Business Name:</label>
                  <input
                    type="text"
                    name="business_name"
                    id="business_name"
                    className="form-control form-input"
                    value={formData.business_name}
                    onChange={handleChange}

                  />
                </div>
              </div>
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="tax_number" className="form-label form-font">VAT Number:</label>
                  <input
                    type="text"
                    name="tax_number"
                    id="tax_number"
                    className="form-control form-input"
                    value={formData.tax_number}
                    onChange={handleChange}
                  />
                </div>
              </div></div>
            <div className="row">
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="pay_term" className="form-label form-font">Pay Term:</label>
                  <input
                    type="text"
                    name="pay_term"
                    id="pay_term"
                    className="form-control form-input"
                    value={formData.pay_term}
                    onChange={handleChange}
                  />

                </div>
              </div>
              <div className="col-md-6">

                <div className="form-group  mb-3">
                  <label htmlFor="pay_term_condition" className="form-label form-font">Pay Term Condition:</label>
                  <select
                    name="pay_term_condition"
                    id="pay_term_condition"
                    className="form-control form-input"
                    value={formData.pay_term_condition}
                    onChange={handleChange}
                  >
                    <option value="">Select Type</option>

                    <option value="months">Months</option>
                    <option value="days">Days</option>
                  </select>

                </div>
              </div></div>

            <div className='row'>
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="email" className="form-label form-font">Email:</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="form-control form-input"
                    value={formData.email}
                    onChange={handleChange}
                  />

                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="mobile" className="form-label form-font">Phone:</label>
                  <input
                    type="text"
                    name="mobile"
                    id="mobile"
                    className="form-control form-input"
                    value={formData.mobile}
                    onChange={handleChange}

                  />
                </div>

              </div>

            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="alternate_contact_no" className="form-label form-font">Alternate Contact No:</label>
                  <input
                    name="alternate_contact_no"
                    id="alternate_contact_no"
                    type="text"
                    className="form-control form-input"
                    value={formData.alternate_contact_no}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-md-6">
                {/* <div className="form-group">
                <label htmlFor="country" className="form-label" style={{ fontSize: '13px' }}>Country:</label>
                <select
                  style={{ fontSize: '13px' }}
                  name="country_id"
                  id="country_id"
                  className="form-control"
                  value={formData.country_id}
                  onChange={handleChange}
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country.id} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div> */}
                <div className="form-group mb-3">
                  <label htmlFor="country" className="form-label form-font">Country:</label>
                  <select
                    name="country_id"
                    id="country_id"
                    className={`form-input form-control ${errors?.country_id ? 'is-invalid' : ''}`}
                    value={formData.country_id}
                    onChange={handleChange}
                  >
                    <option value="">Select Country</option>

                    {/* Show UAE first if it exists */}
                    {(countries || [])
                      .filter((c) => c.name === 'United Arab Emirates')
                      .map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}

                    {/* Then show the rest except UAE */}
                    {(countries || [])
                      .filter((c) => c.name !== 'United Arab Emirates')
                      .map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                  </select>

                  {errors.country_id && <div className="invalid-feedback font-size-12">*{errors.country_id}</div>}

                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="state" className="form-label form-font">State:</label>
                  <input
                    type="text"
                    name="state"
                    id="state"
                    className="form-control form-input"
                    value={formData.state}
                    onChange={handleChange}
                  />
                </div>
              </div>


              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="city" className="form-label form-font">City:</label>
                  <input
                    type="text"
                    name="city"
                    id="city"
                    className="form-control form-input"
                    value={formData.city}
                    onChange={handleChange}

                  />
                </div>

              </div></div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="zip" className="form-label form-font">Zip Code:</label>
                  <input
                    type="text"
                    name="zip"
                    id="zip"
                    className="form-control form-input"
                    value={formData.zip}
                    onChange={handleChange}
                  />
                </div>

              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="address" className="form-label form-font">Address:</label>
                  <textarea
                    name="address"
                    id="address"
                    className="form-control form-input"
                    value={formData.address}
                    onChange={handleChange}

                  />
                </div>

              </div></div>
            <div className="row">
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="tl_registration" className="form-label form-font">TL Registration:</label>
                  <input
                    type="text"
                    name="tl_registration"
                    id="tl_registration"
                    className="form-control form-input"
                    value={formData.tl_registration}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label htmlFor="tl_registration_date" className="form-label form-font">TL Registration Date:</label>
                  <input
                    type="date"
                    name="tl_registration_date"
                    id="tl_registration_date"
                    className="form-control form-input"
                    value={formData.tl_registration_date}
                    onChange={handleChange}
                  />
                </div>
              </div></div>
            <div className="row">
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="tl_registration_doc" className="form-label form-font" >TL Registration Attachment:</label>
                  <input
                    type="file"
                    name="tl_registration_doc"
                    className="form-control form-input"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="tl_expired_date" className="form-label form-font">TL Expired Date:</label>
                  <input
                    type="date"
                    name="tl_expired_date"
                    id="tl_expired_date"
                    className="form-control form-input"
                    value={formData.tl_expired_date}

                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">

                <div className="form-group mb-3">
                  <label htmlFor="avatar" className="form-label form-font">Profile Picture:</label>
                  <input
                    type="file"
                    name="avatar"
                    id="avatar"
                    accept="image/*"

                    className="form-control form-input"
                    onChange={handleFileChange} // handleFileChange should be a function to handle the file upload
                  />
                </div>
              </div>
            </div>
     {type === 'vendor' && (
  <div className="row">
    <div className="col-md-6">
      <div className="form-group mb-3">
        <label htmlFor="rcm_eligible" className="form-label form-font">
          RCM Eligible:
        </label>

        <select
          name="rcm_eligible"
          id="rcm_eligible"
          className="form-select form-select-sm"
          value={
            formData.rcm_eligible === null || formData.rcm_eligible === undefined
              ? ""
              : (formData.rcm_eligible ? "true" : "false")
          }
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              rcm_eligible: e.target.value === "" ? null : (e.target.value === "true"),
            }))
          }
        >
          <option value="">Select</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>
      
    </div>
  </div>
)}


          </form>
        </Offcanvas.Body>
        <div className="p-3 d-flex justify-content-end border-top">
          <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
            Close
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSubmit}>
            Save
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default ClientForm;
